export const DEFAULT_SOLANA_EXPLORER = `https://solscan.io/`;

export const explorerAccountUrl = (address: string) => `${DEFAULT_SOLANA_EXPLORER}account/${address}`;
export const explorerTxUrl = (signature: string) => `${DEFAULT_SOLANA_EXPLORER}tx/${signature}`;
export const explorerTokenUrl = (mint: string) => `${DEFAULT_SOLANA_EXPLORER}token/${mint}`;
